import React, { useEffect, useState } from 'react';
import KenLoader from '../../Components/KenLoader';
import './studentList.css';

import {
  Grid,
  AppBar,
  makeStyles,
  Box,
  Toolbar,
  Typography,
  Tab,
  Tabs,
  Paper,
  Button,
} from '@material-ui/core';
import Filters from '../../Components/Filters/Filters';

import KenCard from '../../global_components/KenCard';
import KenGrid from '../../global_components/KenGrid';

import moment from 'moment';
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '10px',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  normal: {
    color: 'white',
    background: 'green',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      background: 'green',
      color: 'white',
    },
  },
  error: {
    background: 'orange',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      color: 'white',
      background: 'orange',
    },
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
}));
const StudentList = () => {
  const classes = useStyles();
  const [SelectedID, setSelectedID] = useState('');
  const [CourseID, setCourseID] = useState('');
  const [sessionData, setSessionData] = useState([]);

  const [studentData, setstudentData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [faculityName, setfaculityName] = useState('');
  const [sessionName, setsessionName] = useState('');
  const [sessionDate, setsessionDate] = useState('');
  const [sessionEndDate, setsessionEndDate] = useState('');

  const [sessionID, setsessionID] = useState('');
  const colums = [
    {
      Header: 'Student Name',
      accessor: 'StudentName',
      disableGlobalFilter: true,
    },
  ];
  const [columnsForFeedBack, setcolumnsForFeedBack] = useState([]);

  useEffect(() => {
    if (sessionID) {
      const students = sessionData
        .filter((items) => {
          return items.id === sessionID;
        })
        .map((item) => {
          return {
            SessionFeedBackSetup: item.SessionFeedBackSetup,
            SessionStudentFeedBackSetup: item.SessionStudentFeedBackSetup,
            FacultyBooking: item.FacultyBooking,
          };
        });

      const studentsList = [];
      const studentsColumns = [];
      const feedbackPara =
        students[0]?.SessionFeedBackSetup?.feedBackParameters.split(';');
      feedbackPara?.map((items) => {
        studentsColumns.push({
          Header: items,
          accessor: items,
          disableGlobalFilter: true,
        });
      });
      const action = {
        Header: 'Action',
        accessor: 'Action',
        disableGlobalFilter: true,
        Cell: ({ value, row }) => {
          console.log('valuevaluevalue', value);
          return (
            <Box>
              <Button
                variant="primary"
                className={
                  value === 'Submitted' ? classes.normal : classes.error
                }
              >
                {value}
              </Button>
            </Box>
          );
        },
      };
      console.log('students[0]?', students[0]);
      Object.entries(students[0].SessionStudentFeedBackSetup).map(
        ([item, keyVal]) => {
          console.log('keyValkeyValkeyValkeyVal', keyVal);
          let ObjPara = {};
          keyVal.SessionStudentFeedBackCollection.map((items) => {
            if (items.StudentName === keyVal.studentName) {
              ObjPara = {
                ...ObjPara,
                [items.feedBackParameters]: items.rating,
              };
            }
          });
          studentsList.push({
            StudentName: keyVal.studentName,
            ...ObjPara,
            Action: keyVal.status,
          });
        }
      );
      setfaculityName(students[0]?.FacultyBooking?.facultyName);
      setsessionName(students[0]?.SessionFeedBackSetup?.sessionName);
      setsessionDate(students[0]?.SessionFeedBackSetup?.sessionStartDate);
      setsessionEndDate(students[0]?.SessionFeedBackSetup?.sessionStartEnd);
      setcolumnsForFeedBack([...colums, ...studentsColumns, action]);
      setstudentData(studentsList);
    }
  }, [sessionID]);

  return (
    <Box sx={{ width: '100%' }}>
      {loading && <KenLoader />}

      <div position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: '45px' }}>
          <Typography className={classes.title}>Session Feedback</Typography>
        </Toolbar>
      </div>
      <div position="static" elevation={0} className={classes.header}>
        <Filters
          term={true}
          setSelectedID={setSelectedID}
          setCourseID={setCourseID}
          CourseVersion={true}
          sessionFeedback={true}
          courseoff={true}
          setSessionData={setSessionData}
          sessionFilter={true}
          setsessionID={setsessionID}
          setstudentData={setstudentData}
          sessionID={sessionID}
         
        />
      </div>

      <div className="feedbackMainDiv">
        <KenCard elevation={0}>
          <div className="student-list-top-heading">
            {studentData.length > 0 && (
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <b> Faculty Name</b>: {faculityName}
                </Grid>
                <Grid item xs={3}>
                  <b>Session Name</b>: {sessionName}
                </Grid>
                <Grid item xs={3}>
                  <b>Session Date</b>:{' '}
                  {sessionDate && moment(sessionDate).format('DD/MM/YYYY')}
                </Grid>
                <Grid item xs={3}>
                  <b>Session Time</b>:{' '}
                  {sessionDate && moment(sessionDate).format('hh:mm A')} -{' '}
                  {sessionEndDate && moment(sessionEndDate).format('hh:mm A')}
                </Grid>
              </Grid>
            )}
          </div>

          <KenGrid
            columns={columnsForFeedBack}
            data={studentData}
            pagination={{ disabled: false }}
            toolbarDisabled={true}
          />
        </KenCard>
      </div>
    </Box>
  );
};

export default StudentList;
